import axiosInstance from ".";

export const validate = (payload) =>
  axiosInstance.post(`/v1/signup-promos/validate`, payload);
